import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme) => ({
  card: {
    minHeight: "100%",
    display: "flex",
    flexDirection: "column",
  },
  visitsNumberContainer: {
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
    paddingBottom: theme.spacing(1),
  },
  generalPurposeField: {
    marginLeft: "1em",
    minWidth: 270,
  },
  text: {
    marginTop: theme.spacing(1),
  },
  progressSection: {
    marginBottom: theme.spacing(1),
  },
  progressTitle: {
    marginBottom: theme.spacing(2),
  },
  progress: {
    marginBottom: theme.spacing(1),
    backgroundColor: "rgb(236, 236, 236)",
  },
  pieChartLegendWrapper: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-end",
    marginRight: theme.spacing(1),
  },
  legendItemContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  fullHeightBody: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
    justifyContent: "space-between",
  },
  tableWidget: {
    overflowX: "auto",
  },
  progressBarPrimary: {
    backgroundColor: theme.palette.primary.main,
  },
  progressBarWarning: {
    backgroundColor: theme.palette.warning.main,
  },
  performanceLegendWrapper: {
    display: "flex",
    flexGrow: 1,
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  legendElement: {
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(2),
  },
  legendElementText: {
    marginLeft: theme.spacing(1),
  },
  serverOverviewElement: {
    display: "flex",
    alignItems: "center",
    maxWidth: "100%",
  },
  serverOverviewElementText: {
    minWidth: 145,
    paddingRight: theme.spacing(2),
  },
  serverOverviewElementChartWrapper: {
    width: "100%",
  },
  mainChartBody: {
    overflowX: "auto",
  },
  mainChartHeader: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.only("xs")]: {
      flexWrap: "wrap",
    },
  },
  mainChartHeaderLabels: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.only("xs")]: {
      order: 3,
      width: "100%",
      justifyContent: "center",
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(2),
    },
  },
  mainChartHeaderLabel: {
    display: "flex",
    alignItems: "center",
    marginLeft: theme.spacing(3),
  },
  mainChartSelectRoot: {
    borderColor: theme.palette.text.hint + "80 !important",
  },
  mainChartSelect: {
    padding: 10,
    paddingRight: 25,
  },
  mainChartLegentElement: {
    fontSize: "18px !important",
    marginLeft: theme.spacing(1),
  },
  success: {
    backgroundColor: theme.palette.success.main,
    color: "#fff",
  },
  warning: {
    backgroundColor: theme.palette.warning.main,
    color: "#fff",
  },
  secondary: {
    backgroundColor: theme.palette.secondary.main,
    color: "#fff",
  },
  logotypeImage: {
    width: 150,
    height: 80,
    marginTop: "-1.5%",
  },
  uploadButton: {
    display: "flex",
    justifyContent: "center",
    alignSelf: "center",
    marginTop: "1%",
    height: 40,
  },
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  dateFilterField: {
    display: "flex",
    marginRight: theme.spacing(1),
    width: 230,
  },
  paperContainer: {
    padding: theme.spacing(2),
    minHeight: 200,
    minWidth: 500,
    overflow: "visible",
  },
  generalSelectionField: {
    marginTop: "-1%",
    width: "100%",      // antes 250
    maxWidth: "100%",   // antes 250
    "& input::placeholder": { background: "rgba(0,0,0,0)", color: "rgba(0,0,0,1)" },
  },
  pharmacySelectionField: {
    marginTop: "-1%",
    width: "100%",
    maxWidth: "100%",
    "& input::placeholder": { background: "rgba(0,0,0,0)", color: "rgba(0,0,0,1)" },
  },
  counterFooter: {
    display: "flex",
    justifyContent: "flex-end",
    borderTop: "1px solid #eee",
    padding: "6px 12px",
  },

  shake: {
    animation: "$shake 260ms linear",
  },

  "@keyframes shake": {
    "0%": { transform: "translateX(0)" },
    "20%": { transform: "translateX(-5px)" },
    "40%": { transform: "translateX(5px)" },
    "60%": { transform: "translateX(-4px)" },
    "80%": { transform: "translateX(4px)" },
    "100%": { transform: "translateX(0)" },
  },
  popupDivCenter: {
    display: "flex",
    justifyContent: "center",
  },
  buttonSpacing: {
    display: "flex",
    justifyContent: "center",
  },
  filterContainer: {
    maxWidth: 760,
    width: "100%",
    margin: "0 auto",
  },

  filterRow: {
    width: "100%",
    alignItems: "center",
    marginBottom: 12,
  },

  labelCol: {
    textAlign: "left",       // 🔹 Alineamos texto por la izquierda
    paddingLeft: 0,
    paddingRight: 24,        // espacio antes del campo
    width: 180,              // 🔹 ancho fijo igual para todos los labels
    flexShrink: 0,
  },

  fieldCol: {
    flexGrow: 1,
    maxWidth: 560,
  },


  fieldFullWidth: {
    width: "100%",
  },

  sectionTitle: {
    fontWeight: 700,
    marginBottom: 8,
    textAlign: "center",
  },
  dateSelectionField: {
    width: "100%",      // asegurar full width para DateField
  },
  downloadButtonLarge: {
    padding: theme.spacing(3),
    "&:hover": {
      backgroundColor: "#c8e6c9",
      boxShadow: "0 6px 16px rgba(46, 125, 50, 0.3)",
    },
  },
}));
